import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const withRouteContext = (Component, extraProps = {}) => {
  const Sub = (props) => {
    const allProps = { ...extraProps, ...props };
    const { route } = allProps;
    const [context, setContext] = useState(route.getContext());
    const contextSub = (ctx) => {
      setContext(ctx);
    };

    useEffect(() => {
      // Cannot pass directly setContext as the context listener as this listener
      // will be invoked by the route with three arguments which triggers warning
      // on the SetStateAction (here setContext) returned by useState
      // https://github.com/facebook/react/issues/14174
      route.subscribeContextChange(contextSub);
      return () => {
        route.unsubscribeContextChange(contextSub);
      };
    }, [route]);

    return (
      <Component {...allProps} context={context} onContextChange={route.bindedSetContext} />
    );
  };
  Sub.propTypes = {
    route: PropTypes.shape({}).isRequired,
  };
  return Sub;
};

withRouteContext.propTypes = {
  Component: PropTypes.element,
};

export default withRouteContext;
